export default { sha: 'a90bd91a47e32e2137bb278d442e594726f5ed29', buildNumber: 'undefined' }
